/**
 * cds-stock-display.js
 * Muestra disponibilidad de stock por sucursal específica según la comuna del popup.
 * Reemplaza el comportamiento de Amplifica (que sumaba stock de todas las tiendas).
 * v2.3.0 — 2026-09-24 — fix: doble click en checkout ya no salta la validación de stock
 */
(function () {
  'use strict';

  // ─── Inyectar CSS para bundles ANTES del primer paint ─────────────────────
  // Oculta los badges "Agotado" y el botón quick-add de Dawn para productos
  // con tag "bundle". Al usar data-product-tags (server-rendered) el CSS actúa
  // antes del primer paint y Dawn no puede revertirlo aunque reinicialice el DOM.
  (function () {
    var s = document.createElement('style');
    s.textContent =
      '[data-product-tags*="bundle"] [id^="Badge-"].badge,' +
      '[data-product-tags*="bundle"] [id^="NoMediaStandardBadge-"].badge,' +
      '[data-product-tags*="bundle"] .quick-add' +
      '{ display:none !important; }';
    (document.head || document.documentElement).appendChild(s);
  })();

  if (window.__CDS_STOCK_MOUNTED__) return;
  window.__CDS_STOCK_MOUNTED__ = true;

  var LS_KEY      = 'amplifica-shipping-location';
  var CDS_BACKEND = 'https://invernadas-copy-production.up.railway.app';

  // Mapeo de communeId → locationId de Shopify
  // DEBE coincidir con seed-commune-days.js (fuente de verdad)
  var COMMUNE_TO_LOCATION = (function () {
    var map = {};
    // Zona Salvador
    [302,303,305,306,308,309,310,311,312,313,314,316,317,318,319,320,
     321,322,323,324,327,329,330,331,332,337,340,341,342,352
    ].forEach(function (id) { map[id] = '942178329'; });
    // Zona Vitacura
    [304,307,315,325,326,328,333,334,338
    ].forEach(function (id) { map[id] = '86750101753'; });
    // Sur
    map[201] = '37094129739';
    [244,245,267].forEach(function (id) { map[id] = '37094129739'; });
    [252,256].forEach(function (id) { map[id] = '78995718393'; });
    return map;
  })();

  // ─── Estado ───────────────────────────────────────────────────────────────
  function getSaved() {
    try {
      var raw = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (!raw) return null;
      if (raw.comunaId && !raw.communeId) raw.communeId = parseInt(raw.comunaId, 10);
      return raw;
    } catch (e) { return null; }
  }

  function getLocationId() {
    var saved = getSaved();
    if (!saved) return null;
    return COMMUNE_TO_LOCATION[saved.communeId] || null;
  }

  // ─── Helpers de botón ─────────────────────────────────────────────────────
  function markSoldOut(btn) {
    if (!btn) return;
    // Guardar texto original solo la primera vez
    if (!btn.getAttribute('data-cds-original-text')) {
      var orig = btn.textContent.trim();
      if (orig && orig !== 'Agotado') btn.setAttribute('data-cds-original-text', orig);
      btn.setAttribute('data-cds-original-disabled', btn.disabled ? '1' : '0');
    }
    btn.setAttribute('data-cds-soldout', '1');
    if (btn.textContent.trim() !== 'Agotado') btn.textContent = 'Agotado';
    btn.style.background  = '#e0e0e0';
    btn.style.borderColor = '#bdbdbd';
    btn.style.color       = '#757575';
    btn.style.cursor      = 'not-allowed';
    btn.style.opacity     = '1';
  }

  function restoreBtn(btn) {
    if (!btn || btn.getAttribute('data-cds-soldout') !== '1') return;
    btn.removeAttribute('data-cds-soldout');
    btn.disabled = btn.getAttribute('data-cds-original-disabled') === '1';
    var orig = btn.getAttribute('data-cds-original-text');
    if (orig) btn.textContent = orig;
    btn.style.background  = '';
    btn.style.borderColor = '';
    btn.style.color       = '';
    btn.style.cursor      = '';
    btn.style.opacity     = '';
  }

  function findCardBtn(cardEl) {
    return cardEl.querySelector(
      'button[type="submit"]:not([name="checkout"]), button[name="add"], .quick-add__submit, ' +
      '.btn--add-to-cart, .product-form__submit, [data-add-to-cart]'
    );
  }

  // ─── MODO FICHA DE PRODUCTO ───────────────────────────────────────────────
  function fetchProductId(callback) {
    var pid = null;
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (meta && meta.product && meta.product.id) pid = String(meta.product.id);
    } catch (e) {}
    if (pid) { callback(pid); return; }

    var canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { callback(null); return; }
    var match = canonical.href.match(/\/products\/([^/?#]+)/);
    if (!match) { callback(null); return; }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/products/' + match[1] + '.js');
    xhr.onload = function () {
      try { callback(JSON.parse(xhr.responseText).id ? String(JSON.parse(xhr.responseText).id) : null); }
      catch (e) { callback(null); }
    };
    xhr.onerror = function () { callback(null); };
    xhr.send();
  }

  function fetchStock(locationId, productId, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', CDS_BACKEND + '/availability/product?locationId=' + locationId + '&productId=' + productId);
    xhr.onload = function () {
      try { callback(null, JSON.parse(xhr.responseText).variants || []); }
      catch (e) { callback(e, []); }
    };
    xhr.onerror = function () { callback(new Error('network'), []); };
    xhr.send();
  }

  function initProductPage(locationId) {
    fetchProductId(function (productId) {
      if (!productId) return;
      fetchStock(locationId, productId, function (err, variants) {
        if (err || !variants.length) return;

        var stockMap = {};
        variants.forEach(function (v) { stockMap[String(v.id)] = v; });

        function getProductBtn() {
          // En Dawn theme el botón está FUERA del form (sibling del contenedor).
          // Buscar subiendo desde el form hasta encontrar [name="add"] o .product-form__submit
          var form = document.querySelector('form[action*="/cart/add"]');
          if (!form) return null;
          // Subir hasta 5 niveles buscando el botón en el ancestro
          var el = form;
          for (var i = 0; i < 5; i++) {
            el = el.parentElement;
            if (!el) break;
            var found = el.querySelector('[name="add"][type="submit"], .product-form__submit, [id^="ProductSubmitButton"]');
            if (found) return found;
          }
          // Fallback: buscar en el documento completo
          return document.querySelector('.product-form__submit') ||
                 document.querySelector('[id^="ProductSubmitButton"]');
        }

        function getSelectedVarId() {
          var form = document.querySelector('form[action*="/cart/add"]');
          if (!form) return null;
          var input = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
          return input ? String(input.value) : null;
        }

        // En la ficha de producto nunca ocultamos el botón — solo limpiamos
        // cualquier marca previa que haya quedado. La validación de stock real
        // ocurre en checkAndCleanCart cuando el cliente intenta hacer checkout.
        function restoreProductBtn() {
          var btn = getProductBtn();
          if (btn) restoreBtn(btn);
        }

        restoreProductBtn();
        setTimeout(restoreProductBtn, 300);
        setTimeout(restoreProductBtn, 800);
      });
    });
  }

  // ─── Tratamiento de bundles ───────────────────────────────────────────────
  // Inserta un enlace "Ver pack" como hermano del .quick-add (que el CSS ya oculta).
  // No intenta ocultar .quick-add via JS — el CSS inyectado al inicio es suficiente
  // y Dawn no puede revertir reglas CSS aunque reinicialice el DOM.
  function applyBundleTreatment(card, handle) {
    // Siempre marcar (para que scanCards omita el card y para diagnóstico)
    card.setAttribute('data-cds-bundle', '1');

    // Guard específico para la inserción del enlace (evita duplicados en re-runs)
    if (card.querySelector('[data-cds-ver-pack]')) return;

    var quickAddDiv = card.querySelector('.quick-add');
    if (!quickAddDiv) return;

    // Copiar className del botón para que "Ver pack" tenga el mismo estilo de Dawn
    var btn = quickAddDiv.querySelector('button');
    var cls = btn ? btn.className : 'button button--full-width button--secondary';

    var verPack = document.createElement('a');
    verPack.href = '/products/' + handle;
    verPack.className = cls;
    verPack.style.textDecoration = 'none';
    verPack.textContent = 'Ver pack';
    verPack.setAttribute('data-cds-ver-pack', '1');

    quickAddDiv.parentNode.insertBefore(verPack, quickAddDiv.nextSibling);
  }

  // Procesa los cards de bundles insertando el enlace "Ver pack".
  // Se llama diferido (después del evento load) para que Dawn haya inicializado
  // sus custom elements (<quick-add>) y el DOM esté estabilizado.
  function initBundleCards() {
    document.querySelectorAll('[data-product-tags*="bundle"]').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.href.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      applyBundleTreatment(card, m[1]);
    });
  }

  // ─── Fetch datos de producto desde storefront (ID numérico + variants) ──────
  function fetchProductData(handle, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/products/' + handle + '.js');
    xhr.onload = function () {
      try {
        var data = JSON.parse(xhr.responseText);
        callback({ id: String(data.id), variantIds: (data.variants || []).map(function (v) { return String(v.id); }) });
      } catch (e) { callback(null); }
    };
    xhr.onerror = function () { callback(null); };
    xhr.send();
  }

  // ─── Lógica de tarjetas (colección, búsqueda, home, recomendados, etc.) ────
  function scanCards(locationId, root, seenHandles) {
    root = root || document;
    seenHandles = seenHandles || {};

    root.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var m = link.href.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1];
      if (seenHandles[handle]) return;
      seenHandles[handle] = true;

      var card = link.closest('.card-wrapper, .product-card-wrapper, li, article');
      if (!card) card = link.parentElement;

      // En página de producto: excluir cualquier tarjeta que no sea recomendación
      if (window.location.pathname.indexOf('/products/') !== -1 &&
          !card.closest('.recommendations, .related, [id*="recommendation"], [class*="recommendation"], .recently-viewed, [id*="recently"]')) {
        return;
      }

      // Bundles: omitir siempre (la disponibilidad viene del stock virtual de componentes,
      // no del inventory_levels de Shopify que lee este script)
      var isBundleCard = card.getAttribute('data-cds-bundle') === '1' ||
        (card.getAttribute('data-product-tags') || '').split(',').some(function (t) {
          return t.trim() === 'bundle';
        });
      if (isBundleCard) {
        seenHandles[handle] = true;
        return;
      }

      var btn = findCardBtn(card);
      if (!btn) return;

      // Leer variant ID pre-seleccionado de la tarjeta (para single-variant products)
      var varInput   = card.querySelector('input[name="id"]');
      var cardVarId  = varInput && varInput.value ? String(varInput.value) : null;

      // Obtener producto (ID + todos los variants) vía storefront y consultar stock
      fetchProductData(handle, function (product) {
        if (!product) return;

        fetchStock(locationId, product.id, function (err, variants) {
          if (err || !variants.length) return;

          // Si la tarjeta tiene variant pre-seleccionado → evaluar solo ese
          // Si no → evaluar si ALGÚN variant está disponible
          var anyAvailable;
          if (cardVarId) {
            var match = variants.filter(function (v) { return String(v.id) === cardVarId; })[0];
            anyAvailable = match ? match.available : false;
          } else {
            anyAvailable = variants.some(function (v) { return v.available; });
          }

          if (anyAvailable) { restoreBtn(btn); } else { markSoldOut(btn); }
        });
      });
    });
  }

  // MutationObserver para infinite scroll y secciones cargadas dinámicamente
  var _observerLocationId = null;
  var _observerTimer      = null;
  var _observerSeen       = {};

  function startObserver(locationId) {
    if (typeof MutationObserver === 'undefined') return;
    _observerLocationId = locationId;

    var observer = new MutationObserver(function (mutations) {
      var hasNewNodes = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1;
        });
      });
      if (!hasNewNodes) return;

      clearTimeout(_observerTimer);
      _observerTimer = setTimeout(function () {
        initBundleCards();
        scanCards(_observerLocationId, document, _observerSeen);
      }, 300);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ─── VALIDACIÓN DE CARRITO ────────────────────────────────────────────────
  // Elimina automáticamente items sin stock en la sucursal seleccionada
  // y muestra un banner con los productos eliminados.

  var _cartCheckRunning  = false;
  var _checkoutApproved  = false; // true cuando el check ya pasó y el próximo click debe continuar
  // Flag independiente de _cartCheckRunning: esta última también la usa checkAndCleanCart()
  // (no bloqueante, disparada al abrir el drawer). Si compartieran la misma variable, un click
  // en "pagar" mientras el chequeo del drawer sigue corriendo quedaría bloqueado para siempre
  // (preventDefault sin btn.click() de continuación).
  var _checkoutValidationRunning = false;

  function checkAndCleanCart() {
    if (_cartCheckRunning) return;
    var locationId = getLocationId();
    if (!locationId) return;

    _cartCheckRunning = true;

    // Leer carrito actual
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js');
    xhr.onload = function () {
      try {
        var cart = JSON.parse(xhr.responseText);
        var items = cart.items || [];
        if (!items.length) { _cartCheckRunning = false; return; }

        // Agrupar por product_id (evitar duplicados)
        var productMap = {}; // productId → [{ variantId, title, key }]
        items.forEach(function (item) {
          var pid = String(item.product_id);
          if (!productMap[pid]) productMap[pid] = [];
          productMap[pid].push({
            variantId: String(item.variant_id),
            title:     item.product_title || item.title,
            key:       item.key,
          });
        });

        var productIds = Object.keys(productMap);
        var pending    = productIds.length;
        var toRemove   = []; // [{ key, title }]

        productIds.forEach(function (pid) {
          fetchStock(locationId, pid, function (err, variants) {
            if (!err && variants.length) {
              var unavailableIds = {};
              variants.forEach(function (v) {
                if (!v.available) unavailableIds[String(v.id)] = true;
              });
              productMap[pid].forEach(function (item) {
                if (unavailableIds[item.variantId]) {
                  toRemove.push({ key: item.key, title: item.title });
                }
              });
            }
            pending--;
            if (pending === 0) applyCartCleanup(toRemove);
          });
        });
      } catch (e) { _cartCheckRunning = false; }
    };
    xhr.onerror = function () { _cartCheckRunning = false; };
    xhr.send();
  }

  function applyCartCleanup(toRemove, onDone) {
    _cartCheckRunning = false;
    if (!toRemove.length) {
      if (onDone) onDone();
      return;
    }

    // Eliminar cada item del carrito
    var pending = toRemove.length;
    toRemove.forEach(function (item) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/change.json');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function () {
        pending--;
        if (pending === 0) {
          showCartWarning(toRemove.map(function (i) { return i.title; }));
        }
      };
      xhr.send(JSON.stringify({ id: item.key, quantity: 0 }));
    });
  }

  function showCartWarning(titles) {
    var existing = document.getElementById('cds-cart-warning-overlay');
    if (existing) existing.remove();

    var saved   = getSaved();
    var commune = saved ? (saved.communeName || saved.comunaName || '') : '';

    // Overlay oscuro
    var overlay = document.createElement('div');
    overlay.id = 'cds-cart-warning-overlay';
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:99998',
      'background:rgba(0,0,0,0.55)', 'display:flex',
      'align-items:center', 'justify-content:center',
      'padding:16px',
    ].join(';');

    // Modal centrado
    var modal = document.createElement('div');
    modal.style.cssText = [
      'background:#fff', 'border-radius:12px', 'padding:28px 24px',
      'max-width:440px', 'width:100%', 'box-shadow:0 8px 32px rgba(0,0,0,0.2)',
      'font-family:inherit', 'position:relative',
    ].join(';');

    modal.innerHTML =
      '<div style="text-align:center;margin-bottom:16px">' +
        '<span style="font-size:32px">⚠️</span>' +
      '</div>' +
      '<h3 style="margin:0 0 8px;font-size:16px;color:#c0392b;text-align:center">' +
        'Productos eliminados del carrito' +
      '</h3>' +
      '<p style="margin:0 0 12px;font-size:14px;color:#444;text-align:center">' +
        'Los siguientes productos no están disponibles' +
        (commune ? ' en <strong>' + commune + '</strong>' : ' en tu sucursal seleccionada') + ':' +
      '</p>' +
      '<ul style="margin:0 0 20px;padding-left:20px;font-size:14px;color:#444;text-align:left">' +
        titles.map(function (t) { return '<li style="margin-bottom:4px">' + t + '</li>'; }).join('') +
      '</ul>' +
      '<button id="cds-cart-warning-close" style="' +
        'display:block;width:100%;padding:12px;background:#c0392b;color:#fff;' +
        'border:none;border-radius:8px;font-size:15px;font-weight:600;cursor:pointer' +
      '">Entendido</button>';

    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    document.getElementById('cds-cart-warning-close').addEventListener('click', function () {
      overlay.remove();
    });
  }

  function checkAndCleanCartBlocking(e) {
    // Si el check ya validó el carrito, dejar pasar este click sin bloquearlo
    if (_checkoutApproved) {
      _checkoutApproved = false;
      return;
    }

    var locationId = getLocationId();
    if (!locationId) return;

    // Bloquear SIEMPRE la navegación mientras haya comuna seleccionada — incluso si ya hay
    // una validación de checkout en curso (evita que un doble click salte el chequeo y el
    // cliente llegue al checkout mientras el carrito todavía se está limpiando atrás).
    e.preventDefault();
    e.stopImmediatePropagation();

    if (_checkoutValidationRunning) return; // ya hay una validación de checkout en curso

    // e.currentTarget es `document` (listener en document) — usar closest para obtener el botón real
    var btn = e.target.closest('[name="checkout"], [href="/checkout"], .cart__checkout-button, #checkout') || e.target;

    _checkoutValidationRunning = true;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js');
    xhr.onload = function () {
      try {
        var cart = JSON.parse(xhr.responseText);
        var items = cart.items || [];
        if (!items.length) {
          _checkoutValidationRunning = false;
          _checkoutApproved = true;
          btn.click();
          return;
        }

        var productMap = {};
        items.forEach(function (item) {
          var pid = String(item.product_id);
          if (!productMap[pid]) productMap[pid] = [];
          productMap[pid].push({
            variantId: String(item.variant_id),
            title:     item.product_title || item.title,
            key:       item.key,
          });
        });

        var productIds = Object.keys(productMap);
        var pending    = productIds.length;
        var toRemove   = [];

        productIds.forEach(function (pid) {
          fetchStock(locationId, pid, function (err, variants) {
            if (!err && variants.length) {
              var unavailableIds = {};
              variants.forEach(function (v) { if (!v.available) unavailableIds[String(v.id)] = true; });
              productMap[pid].forEach(function (item) {
                if (unavailableIds[item.variantId]) toRemove.push({ key: item.key, title: item.title });
              });
            }
            pending--;
            if (pending === 0) {
              applyCartCleanup(toRemove, function () {
                // Todo ok — marcar aprobado y re-disparar el click (solo pasa una vez)
                _checkoutValidationRunning = false;
                _checkoutApproved = true;
                btn.click();
              });
            }
          });
        });
      } catch (err) { _checkoutValidationRunning = false; _checkoutApproved = true; btn.click(); }
    };
    xhr.onerror = function () { _checkoutValidationRunning = false; _checkoutApproved = true; btn.click(); };
    xhr.send();
  }

  // Limpiar estilos inline que markSoldOut pudo haber puesto sobre el botón checkout
  function protectCheckoutBtn() {
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      if (btn.getAttribute('data-cds-soldout') !== '1') return;
      restoreBtn(btn);
    });
  }

  function initCartCheck() {
    // Limpiar en carga y a 500ms/1500ms por si el tema renderiza el botón tarde
    protectCheckoutBtn();
    setTimeout(protectCheckoutBtn, 500);
    setTimeout(protectCheckoutBtn, 1500);

    // Correr al cargar la página del carrito (sin bloquear)
    if (window.location.pathname === '/cart') {
      checkAndCleanCart();
    }

    // Interceptar checkout: bloquear navegación, verificar, continuar solo si no hay remociones
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="checkout"], [href="/checkout"], .cart__checkout-button, #checkout');
      if (!btn) return;
      checkAndCleanCartBlocking(e);
    }, true); // capture=true para interceptar antes que el tema

    // Escuchar apertura del cart drawer
    document.addEventListener('cart:open',        checkAndCleanCart);
    document.addEventListener('cart-drawer:open', checkAndCleanCart);
    document.addEventListener('on:cart:open',     checkAndCleanCart);
  }

  // ─── Init principal ───────────────────────────────────────────────────────
  function init() {
    var locationId = getLocationId();
    if (!locationId) return;

    // Ficha de producto principal
    if (window.location.pathname.indexOf('/products/') !== -1) {
      initProductPage(locationId);
    }

    // Tarjetas en cualquier página (bundles ya filtrados por scanCards via data-product-tags)
    var seen = {};
    scanCards(locationId, document, seen);
    startObserver(locationId);
  }

  // Reiniciar al cambiar la comuna en el popup
  window.addEventListener('storage', function (e) {
    if (e.key !== LS_KEY) return;
    document.querySelectorAll('[data-cds-soldout="1"]').forEach(restoreBtn);
    _observerSeen = {};
    window.__CDS_STOCK_MOUNTED__ = false;
    window.__CDS_STOCK_MOUNTED__ = true;
    init();
  });

  // "Ver pack" para bundles: diferir hasta el evento load para que los custom
  // elements de Dawn (<quick-add>) hayan completado su connectedCallback y el
  // DOM esté estabilizado. El CSS ya oculta .quick-add desde el primer paint.
  if (document.readyState === 'complete') {
    setTimeout(initBundleCards, 100);
  } else {
    window.addEventListener('load', function () { setTimeout(initBundleCards, 100); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initCartCheck(); });
  } else {
    init();
    initCartCheck();
  }
})();
